import { motion } from "framer-motion";
import { USE_CASES } from "@/data/content";
import { Reveal } from "./Reveal";

export const UseCases = () => (
  <section id="use-cases" className="relative border-t border-white/10 py-28 md:py-40" data-testid="use-cases">
    <div className="ec-container">
      <Reveal className="mb-16">
        <p className="ec-eyebrow mb-4">
          <span className="h-1.5 w-1.5 rounded-full bg-[#D4F870]" />
          KULLANIM ALANLARI
        </p>
        <h2 className="max-w-3xl font-display text-4xl leading-[1.02] tracking-tight text-[#F3F4F6] sm:text-5xl md:text-6xl">
          KOBİ'den doğrulayıcıya, herkes için.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {USE_CASES.map((u, i) => {
          const Icon = u.icon;
          return (
            <motion.div
              key={u.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              className="group rounded-2xl border border-white/5 bg-[#121212] p-8 transition-colors duration-300 hover:border-white/20"
              data-testid={`use-case-${i}`}
            >
              <Icon className="h-7 w-7 text-[#D4F870] transition-transform duration-300 group-hover:-translate-y-1" strokeWidth={1.6} />
              <h3 className="mt-6 font-display text-xl text-[#F3F4F6]">{u.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#9CA3AF]">{u.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
